import React from 'react';

import PageSkeleton from '../../components/skeleton/PageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const ADVANCED_SEARCH_PAGE_CHUNK_NAME = 'advancedSearchPage';

export const AdvancedSearchPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "advancedSearchPage" */ '../../pages/AdvancedSearchPage'
    ),
  {
    fallback: <PageSkeleton />,
  }
);
